import { useRef } from 'react';

import { useLocation, useNavigationType } from 'react-router-dom';

/** URL replacements follow filters; a new history entry must seed the report from its own URL. */
export function useViewEntryRevision(): number {
  const location = useLocation();
  const navigation = useNavigationType();
  const entry = useRef({ key: location.key, revision: 0 });
  if (entry.current.key !== location.key) {
    entry.current = { key: location.key, revision: entry.current.revision + (navigation === 'REPLACE' ? 0 : 1) };
  }
  return entry.current.revision;
}
